import React from 'react';
import { Reveal } from './Reveal';
import { benefits, phases } from '../data/content';
export function Benefits() {
  return <section id="beneficios" className="w-full scroll-mt-16 bg-mint py-16 sm:py-20" data-id="element-22" data-mp="9cgya824csol">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-23" data-mp="4jnw9ry1byg7">
        <Reveal className="text-center" data-id="element-24" data-mp="4i2yltgfbze4">
          <p className="text-[13px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-25" data-mp="3vrid7dksh88s">
            Lo que experimentarás
          </p>
          <h2 className="mt-3 text-[28px] font-bold tracking-tight text-forest sm:text-[36px]" data-id="element-26" data-mp="3qsyudm1hsckn">
            En 21 Días, Tu Cuerpo Se Transforma
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[17px] leading-relaxed text-charcoal" data-id="element-27" data-mp="3hq633isb80ut">
            Esto no es una promesa — es la biología del protocolo funcionando.
          </p>
        </Reveal>

        {/* Timeline */}
        <div className="relative mt-12" data-id="element-28" data-mp="1fz2oyjj7o45i">
          <div className="absolute left-[27px] top-6 hidden h-[calc(100%-3rem)] border-l-2 border-dashed border-gold/50 sm:block md:left-0 md:top-[27px] md:h-0 md:w-full md:border-l-0 md:border-t-2" aria-hidden="true" data-id="element-29" data-mp="1b0hxb8i0ysso" />
          <ol className="relative grid gap-8 md:grid-cols-3 md:gap-6" data-id="element-30" data-mp="6tb26qo86g36">
            {phases.map((phase, i) => <Reveal as="li" key={phase.number} delay={i * 0.08} className="flex gap-4 md:flex-col md:items-center md:gap-0 md:text-center" data-id="element-31" data-mp="3oyxpzubo1kio" data-mpi={i}>
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gold font-mono text-xl font-bold text-forest ring-8 ring-mint" data-id="element-32" data-mp="3txr7dxu2pvo4">
                  {phase.number}
                </span>
                <div className="md:mt-4" data-id="element-33" data-mp="qilgc08bosz6">
                  <p className="text-[12px] font-semibold uppercase tracking-widest text-warmgray" data-id="element-34" data-mp="bsnxlzt5wvhd">
                    Fase {phase.number} · {phase.days}
                  </p>
                  <h3 className="mt-1 text-lg font-bold uppercase tracking-tight text-forest" data-id="element-35" data-mp="14gticmk7ukh7">
                    {phase.name}
                  </h3>
                  <p className="mt-2 max-w-xs text-sm leading-relaxed text-charcoal/75 md:mx-auto" data-id="element-36" data-mp="198ur3yi6dt2h">
                    {phase.detail}
                  </p>
                </div>
              </Reveal>)}
          </ol>
        </div>

        {/* Benefits grid */}
        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-37" data-mp="194jglqw184am">
          {benefits.map(({
          icon: Icon,
          title,
          detail
        }, i) => <Reveal as="li" key={title} delay={i * 0.06} className="flex h-full items-start gap-4 rounded-xl bg-white p-5 shadow-sm" data-id="element-38" data-mp="1537qzld5rj2f" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gold/10" data-id="element-39" data-mp="vdxxc12o1sc7">
                <Icon className="h-6 w-6 text-gold" strokeWidth={1.8} aria-hidden="true" data-id="element-40" data-mp="qebhdjvgdxzp" />
              </span>
              <div data-id="element-41" data-mp="lg9oy8c50mbk">
                <h3 className="text-[15px] font-bold leading-snug tracking-tight text-charcoal" data-id="element-42" data-mp="lgt79q5p9cq4">
                  {title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-warmgray" data-id="element-43" data-mp="hfpw3gylk4v8">{detail}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}